import React, { useEffect, useState } from "react";
import { Row, Col } from "reactstrap";
import CustomForm from "../../../custom/Forms/CustomForm";
import { useParams } from "react-router-dom";
import DownloadExcel, {
  formatNumber,
  getRecords,
} from "../../../services/api.service";
import { CSVLink } from "react-csv";

const AvailableStocks = () => {
  const { id } = useParams;
  const [searchKeyword, setSearchKeyword] = useState("");
  const [data, setData] = useState([]);
  const [expandedProjects, setExpandedProjects] = useState({});
  const [expandedWarehouses, setExpandedWarehouses] = useState({});
  const [expandedCategories, setExpandedCategories] = useState({});
  const [expandedItems, setExpandedItems] = useState({});
  const [loadingData, setLoadingData] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 10;
  const [typeCostQTY, setTypeCostQTY] = useState(null);
  const [warehouseData, setWarehouseData] = useState({});
  const [categoryData, setCategoryData] = useState({});

  const [itemsData, setItemsData] = useState({});
  const [subItemsData, setSubItemsData] = useState({});

  const [csvData, setCsvData] = useState([]);

  const toggleProject = async (pIndex, project) => {
    if (!expandedProjects[pIndex]) {
      try {
        const payload = {
          level: "warehouses",
          project_id: project.id,
        };

        let responseData = await getRecords(
          payload,
          "/dashboard/availableStock"
        );

        setWarehouseData((prev) => ({
          ...prev,
          [project.id]: responseData.code == 1 ? responseData.data : [],
        }));
        setLoadingData(false);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    } else {
      setWarehouseData((prev) => ({ ...prev, [project.id]: [] }));
      setCategoryData({});
      setItemsData({});
      setSubItemsData({});
      setExpandedCategories({});
      setExpandedWarehouses({});
      setExpandedItems({});
    }
    setExpandedProjects((prev) => ({
      ...prev,
      [pIndex]: !prev[pIndex],
    }));
  };

  const toggleWarehouse = async (pIndex, wIndex, project, warehouse) => {
    if (!expandedWarehouses[`${pIndex}-${wIndex}`]) {
      try {
        const payload = {
          level: "categories",
          warehouse_id: warehouse.id,
          project_id: project.id,
        };

        let responseData = await getRecords(
          payload,
          "/dashboard/availableStock"
        );

        setCategoryData((prev) => ({
          ...prev,
          [`${project.id}-${warehouse.id}`]:
            responseData.code === 1 ? responseData.data : [],
        }));
        setLoadingData(false);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    } else {
      setCategoryData((prev) => ({
        ...prev,
        [`${project.id}-${warehouse.id}`]: [],
      }));
      setItemsData({});
      setExpandedCategories({});
    }

    setExpandedWarehouses((prev) => ({
      ...prev,
      [`${pIndex}-${wIndex}`]: !prev[`${pIndex}-${wIndex}`],
    }));
  };
  const toggleBuyItem = async (
    pIndex,
    wIndex,
    cIndex,
    iIndex,
    project,
    warehouse,
    category,
    item
  ) => {
    if (!expandedItems[`${pIndex}-${wIndex}-${cIndex}-${iIndex}`]) {
      try {
        const payload = {
          level: "buy_items",
          project_id: project.id,
          warehouse_id: warehouse.id,
          category_id: category.id,
          item_id: item.id,
        };

        let responseData = await getRecords(
          payload,
          "/dashboard/availableStock"
        );

        setSubItemsData((prev) => ({
          ...prev,
          [`${project.id}-${warehouse.id}-${category.id}-${item.id}`]:
            responseData.code === 1 ? responseData.data : [],
        }));
        setLoadingData(false);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    } else {
      setSubItemsData((prev) => ({
        ...prev,
        [`${project.id}-${warehouse.id}-${category.id}-${item.id}`]: [],
      }));
    }

    setExpandedItems((prev) => ({
      ...prev,
      [`${pIndex}-${wIndex}-${cIndex}-${iIndex}`]:
        !prev[`${pIndex}-${wIndex}-${cIndex}-${iIndex}`],
    }));
  };

  const toggleCategory = async (
    pIndex,
    wIndex,
    cIndex,
    project,
    warehouse,
    category
  ) => {
    if (!expandedCategories[`${pIndex}-${wIndex}-${cIndex}`]) {
      try {
        const payload = {
          level: "items",
          project_id: project.id,
          warehouse_id: warehouse.id,
          category_id: category.id,
        };

        let responseData = await getRecords(
          payload,
          "/dashboard/availableStock"
        );

        setItemsData((prev) => ({
          ...prev,
          [`${project.id}-${warehouse.id}-${category.id}`]:
            responseData.code === 1 ? responseData.data : [],
        }));
        setLoadingData(false);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    } else {
      setItemsData((prev) => ({
        ...prev,
        [`${project.id}-${warehouse.id}-${category.id}`]: [],
      }));
      setSubItemsData({});
      setExpandedItems({});
    }

    setExpandedCategories((prev) => ({
      ...prev,
      [`${pIndex}-${wIndex}-${cIndex}`]:
        !prev[`${pIndex}-${wIndex}-${category.id}`],
    }));
  };

  useEffect(() => {
    fetchReports(); // Fetch initial data
    fetchCSVReports();

    // Event Listener for localStorage changes
    const handleStorageChange = () => {
      fetchReports();
      fetchCSVReports();
    };

    // Listen for the custom event
    window.addEventListener("dashboardUpdate", handleStorageChange);

    return () => {
      window.removeEventListener("dashboardUpdate", handleStorageChange);
    };
  }, []);

  const fetchReports = async (Id) => {
    try {
      setLoadingData(true);
      const dashboard_details = localStorage.getItem("dashboard_details");
      if (!dashboard_details) return;

      const payload = {
        level: "projects",
        project_id: JSON.parse(dashboard_details).project_id,
      };
      setTypeCostQTY(JSON.parse(dashboard_details).type);
      let responseData = await getRecords(payload, "/dashboard/availableStock");
      if (responseData.data.length == 0) {
        setData([]);
        setLoadingData(false);
      }
      if (responseData.data && responseData.data.length > 0) {
        setData(responseData.data);
        setLoadingData(false);
      } else {
        setData([]);
        setLoadingData(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchCSVReports = async () => {
    try {
      setLoadingData(true);
      const dashboard_details = localStorage.getItem("dashboard_details");
      if (!dashboard_details) return;

      const payload = {
        ...JSON.parse(dashboard_details),
      };

      setTypeCostQTY(payload.type);
      let responseData = await getRecords(
        payload,
        "/dashboard/availableStockOld"
      );

      if (responseData.code == 1 && responseData.data.length > 0) {
        setCsvData(responseData.data || []);
        setLoadingData(false);
      } else {
        setCsvData([]);
        setLoadingData(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchKeyword(value);
    setCurrentPage(1);
  };

  const filteredItems =
    data.filter((row) => {
      const projectNameMatch = row?.project_name
        ?.toLowerCase()
        .includes(searchKeyword.toLowerCase());

      const warehouseMatch = row?.warehouses?.some((warehouse) =>
        warehouse?.warehouse_name
          ?.toLowerCase()
          .includes(searchKeyword.toLowerCase())
      );

      const categoryMatch = row?.warehouses?.some((warehouse) =>
        warehouse?.categories?.some((category) =>
          category?.category_name
            ?.toLowerCase()
            .includes(searchKeyword.toLowerCase())
        )
      );

      const itemMatch = row?.warehouses?.some((warehouse) =>
        warehouse?.categories?.some((category) =>
          category?.items?.some((item) =>
            item?.item_code?.toLowerCase().includes(searchKeyword.toLowerCase())
          )
        )
      );

      const buyItemMatch = row?.warehouses?.some((warehouse) =>
        warehouse?.categories?.some((category) =>
          category?.items?.some((item) =>
            item?.buy_items?.some((buyItem) =>
              buyItem?.item_code
                ?.toLowerCase()
                .includes(searchKeyword.toLowerCase())
            )
          )
        )
      );

      return (
        projectNameMatch ||
        warehouseMatch ||
        categoryMatch ||
        itemMatch ||
        buyItemMatch
      );
    }) || [];

  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredItems.slice(
    indexOfFirstRecord,
    indexOfLastRecord
  );

  const totalPages = Math.ceil(filteredItems.length / recordsPerPage);

  const handleExportData = () => {
    const { columns, rows } = generateCSVData();

    DownloadExcel({
      fileName: "AvailableStocks",
      columns: columns,
      data: rows,
      cellColor: false,
    });
  };

  const generateCSVData = () => {
    const columns = [
      { label: "Sr No", key: "srNo" },
      { label: "Project Name", key: "project_name" },
      { label: "Project Code", key: "project_code" },
      {
        label: typeCostQTY == "cost" ? "Stock Cost" : "Stock Qty",
        key: "stock_qty",
      },
      {
        label: `Provision ${typeCostQTY === "cost" ? "Cost" : "Qty"}`,
        key: "provision_qty",
      },
      {
        label: `Shortage ${typeCostQTY === "cost" ? "Cost" : "Qty"}`,
        key: "shortage_qty",
      },
      {
        label: `MRB ${typeCostQTY === "cost" ? "Cost" : "Qty"}`,
        key: "mrb_qty",
      },
      {
        label: `Scrap ${typeCostQTY === "cost" ? "Cost" : "Qty"}`,
        key: "scrap_qty",
      },
    ];

    const rows = [];

    csvData?.forEach((project, pIndex) => {
      if (pIndex !== 0) {
        // Empty Row Before New Project
        rows.push({
          srNo: "",
          project_name: "",
          project_code: "",
          stock_qty: "",
          provision_qty: "",
          shortage_qty: "",
          mrb_qty: "",
          scrap_qty: "",
        });
      }
      rows.push({
        srNo: pIndex + 1,
        project_name: project?.project_name || "N/A",
        project_code: project?.project_code || "N/A",
        stock_qty:
          typeCostQTY === "cost"
            ? project?.stock_qty_cost || "0"
            : project?.stock_qty || "0",
        provision_qty:
          typeCostQTY === "cost"
            ? project?.provision_qty_cost || "0"
            : project?.provision_qty || "0",
        shortage_qty:
          typeCostQTY === "cost"
            ? project?.shortage_qty_cost || "0"
            : project?.shortage_qty || "0",
        mrb_qty:
          typeCostQTY === "cost"
            ? project?.mrb_qty_cost || "0"
            : project?.mrb_qty || "0",
        scrap_qty:
          typeCostQTY === "cost"
            ? project?.scrab_qty_cost || "0"
            : project?.scrab_qty || "0",
      });

      project?.warehouses?.forEach((warehouse) => {
        // Warehouse Heading
        rows.push({
          srNo: "",
          project_name: "Warehouse Name",
          project_code: "Warehouse Type",
          stock_qty: `Stock ${typeCostQTY === "cost" ? "Cost" : "Qty"}`,
          provision_qty: `Provision ${typeCostQTY === "cost" ? "Cost" : "Qty"}`,
          shortage_qty: `Shortage ${typeCostQTY === "cost" ? "Cost" : "Qty"}`,
          mrb_qty: `MRB ${typeCostQTY === "cost" ? "Cost" : "Qty"}`,
          scrap_qty: `Scrap ${typeCostQTY === "cost" ? "Cost" : "Qty"}`,
          isHeader: true,
        });
        rows.push({
          project_name: warehouse?.warehouse_name || "N/A",
          project_code: warehouse?.type === 1 ? "Bermad" : "Contractor",
          stock_qty:
            typeCostQTY === "cost"
              ? warehouse?.stock_qty_cost || "0"
              : warehouse?.stock_qty || "0",
          provision_qty:
            typeCostQTY === "cost"
              ? warehouse?.provision_qty_cost || "0"
              : warehouse?.provision_qty || "0",
          shortage_qty:
            typeCostQTY === "cost"
              ? warehouse?.shortage_qty_cost || "0"
              : warehouse?.shortage_qty || "0",
          mrb_qty:
            typeCostQTY === "cost"
              ? warehouse?.mrb_qty_cost || "0"
              : warehouse?.mrb_qty || "0",
          scrap_qty:
            typeCostQTY === "cost"
              ? warehouse?.scrab_qty_cost || "0"
              : warehouse?.scrab_qty || "0",
        });

        warehouse?.categories?.forEach((category) => {
          // Category Heading
          rows.push({
            srNo: "",
            project_name: "",
            project_code: "Category Name",
            stock_qty: `Stock ${typeCostQTY === "cost" ? "Cost" : "Qty"}`,
            provision_qty: `Provision ${
              typeCostQTY === "cost" ? "Cost" : "Qty"
            }`,
            shortage_qty: `Shortage ${typeCostQTY === "cost" ? "Cost" : "Qty"}`,
            mrb_qty: `MRB ${typeCostQTY === "cost" ? "Cost" : "Qty"}`,
            scrap_qty: `Scrap ${typeCostQTY === "cost" ? "Cost" : "Qty"}`,
            isHeader1: true,
          });
          rows.push({
            project_code: category?.category_name || "N/A",
            stock_qty:
              typeCostQTY === "cost"
                ? category?.stock_qty_cost || "0"
                : category?.stock_qty || "0",
            provision_qty:
              typeCostQTY === "cost"
                ? category?.provision_qty_cost || "0"
                : category?.provision_qty || "0",
            shortage_qty:
              typeCostQTY === "cost"
                ? category?.shortage_qty_cost || "0"
                : category?.shortage_qty || "0",
            mrb_qty:
              typeCostQTY === "cost"
                ? category?.mrb_qty_cost || "0"
                : category?.mrb_qty || "0",
            scrap_qty:
              typeCostQTY === "cost"
                ? category?.scrab_qty_cost || "0"
                : category?.scrab_qty || "0",
          });

          // Item Heading
          rows.push({
            srNo: "Sr No",
            project_name: "Item Code",
            project_code: "Item Description",
            stock_qty: `Stock ${typeCostQTY === "cost" ? "Cost" : "Qty"}`,
            provision_qty: `Provision ${
              typeCostQTY === "cost" ? "Cost" : "Qty"
            }`,
            shortage_qty: `Shortage ${typeCostQTY === "cost" ? "Cost" : "Qty"}`,
            mrb_qty: `MRB ${typeCostQTY === "cost" ? "Cost" : "Qty"}`,
            scrap_qty: `Scrap ${typeCostQTY === "cost" ? "Cost" : "Qty"}`,
            isHeader2: true,
          });

          category?.items?.forEach((item, iIndex) => {
            rows.push({
              srNo: iIndex + 1,
              project_name: item?.item_code || "N/A",
              project_code: item?.description || "N/A",
              stock_qty:
                item?.type === 1
                  ? "-"
                  : typeCostQTY === "cost"
                  ? item?.stock_qty_cost || "0"
                  : item?.stock_qty || "0",
              provision_qty:
                item?.type === 1
                  ? "-"
                  : typeCostQTY === "cost"
                  ? item?.provision_qty_cost || "0"
                  : item?.provision_qty || "0",
              shortage_qty:
                item?.type === 1
                  ? "-"
                  : typeCostQTY === "cost"
                  ? item?.shortage_qty_cost || "0"
                  : item?.shortage_qty || "0",
              mrb_qty:
                item?.type === 1
                  ? "-"
                  : typeCostQTY === "cost"
                  ? item?.mrb_qty_cost || "0"
                  : item?.mrb_qty || "0",
              scrap_qty:
                item?.type === 1
                  ? "-"
                  : typeCostQTY === "cost"
                  ? item?.scrab_qty_cost || "0"
                  : item?.scrab_qty || "0",
            });

            if (item?.type === 1 && item?.buy_items) {
              item?.buy_items?.forEach((buyItem, bIndex) => {
                rows.push({
                  srNo: `${iIndex + 1}.${bIndex + 1}`,
                  project_name: buyItem?.item_code || "N/A",
                  project_code: buyItem?.description || "N/A",
                  stock_qty:
                    typeCostQTY === "cost"
                      ? buyItem?.stock_qty_cost || "0"
                      : buyItem?.stock_qty || "0",
                  provision_qty:
                    typeCostQTY === "cost"
                      ? buyItem?.provision_qty_cost || "0"
                      : buyItem?.provision_qty || "0",
                  shortage_qty:
                    typeCostQTY === "cost"
                      ? buyItem?.shortage_qty_cost || "0"
                      : buyItem?.shortage_qty || "0",
                  mrb_qty:
                    typeCostQTY === "cost"
                      ? buyItem?.mrb_qty_cost || "0"
                      : buyItem?.mrb_qty || "0",
                  scrap_qty:
                    typeCostQTY === "cost"
                      ? buyItem?.scrab_qty_cost || "0"
                      : buyItem?.scrab_qty || "0",
                });
              });
            }
          });
        });
      });
    });

    return { columns, rows };
  };

  return (
    <CustomForm
      title={"AVAILABLE STOCK REPORT"}
      id={id}
      loadingData={loadingData}
      noBackButton={true}
      noSubmitButton={true}
    >
      <Row className="mt-1" style={{}}>
        <Col lg={12}>
          <div className="">
            <div className="mb-2 d-flex justify-content-between align-items-center text-white">
              <div>
                <input
                  type="search"
                  className="form-control"
                  placeholder="Search by project name.."
                  value={searchKeyword}
                  onChange={handleInputChange}
                  style={{
                    width: "15rem",
                    padding: "8px 15px",
                    borderRadius: "8px",
                    borderColor: "#D2D2D2",
                  }}
                />
              </div>
              <div>
                <div onClick={handleExportData} className="btn btn-success">
                  Download CSV
                </div>
              </div>
            </div>

            <div className="card-body p-0 position-relative">
              <div
                className=""
                style={{
                  height: "500px",
                  overflowX: "auto",
                  overflowY: "auto",
                  width: "100%",
                  scrollBehavior: "smooth",
                  scrollbarWidth: "thin",
                  msOverflowStyle: "none",
                  zIndex: 0,
                }}
              >
                <table
                  className="table  table-bordered, table-striped,  table-hover"
                  style={{
                    border: "1px solid black",
                  }}
                >
                  <thead style={{ position: "sticky", top: "0px" }}>
                    <tr
                      style={{ backgroundColor: "#6FAFDB", fontWeight: "900" }}
                    >
                      <th style={{ whiteSpace: "nowrap" }}> Sr No </th>
                      <th style={{ whiteSpace: "nowrap" }}> Project Name </th>
                      <th style={{ whiteSpace: "nowrap" }}>Project Code</th>
                      <th style={{ whiteSpace: "nowrap" }}>
                        Stock {typeCostQTY == "cost" ? "Cost" : "Qty"}
                      </th>
                      <th style={{ whiteSpace: "nowrap" }}>
                        Provision {typeCostQTY == "cost" ? "Cost" : "Qty"}
                      </th>
                      <th style={{ whiteSpace: "nowrap" }}>
                        Shortage {typeCostQTY == "cost" ? "Cost" : "Qty"}
                      </th>
                      <th style={{ whiteSpace: "nowrap" }}>
                        MRB {typeCostQTY == "cost" ? "Cost" : "Qty"}
                      </th>
                      <th style={{ whiteSpace: "nowrap" }}>
                        Scrap {typeCostQTY == "cost" ? "Cost" : "Qty"}
                      </th>
                      <th style={{ whiteSpace: "nowrap" }}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentRecords?.length > 0 ? (
                      currentRecords?.map((project, pIndex) => (
                        <React.Fragment key={pIndex}>
                          <tr
                            onClick={() => toggleProject(pIndex, project)}
                            key={pIndex}
                          >
                            <td style={{ fontWeight: "3000" }}>
                              {indexOfFirstRecord + pIndex + 1}
                            </td>
                            <td
                              style={{
                                paddingLeft: "10px",
                                paddingRight: "2px",
                                minWidth: "180px",
                              }}
                            >
                              <div
                                style={{
                                  display: "-webkit-box",
                                  WebkitBoxOrient: "vertical",
                                  WebkitLineClamp: 2,
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "normal",
                                  wordBreak: "break-word",
                                  overflowWrap: "break-word",
                                }}
                                title={project?.project_name || "N/A"}
                              >
                                {project?.project_name || "N/A"}
                              </div>
                            </td>
                            <td>{project.project_code || "0"}</td>
                            <td>
                              {typeCostQTY == "cost"
                                ? formatNumber(project.stock_qty_cost)
                                : formatNumber(project.stock_qty || "0")}
                            </td>
                            <td>
                              {typeCostQTY == "cost"
                                ? formatNumber(project.provision_qty_cost)
                                : formatNumber(project.provision_qty || "0")}
                            </td>
                            <td>
                              {typeCostQTY == "cost"
                                ? formatNumber(project.shortage_qty_cost)
                                : formatNumber(project.shortage_qty || "0")}
                            </td>
                            <td>
                              {typeCostQTY == "cost"
                                ? formatNumber(project.mrb_qty_cost)
                                : formatNumber(project.mrb_qty || "0")}
                            </td>
                            <td>
                              {typeCostQTY == "cost"
                                ? formatNumber(project.scrab_qty_cost)
                                : formatNumber(project.scrab_qty || "0")}
                            </td>
                            <td style={{ color: "black" }}>
                              <i
                                className={`mdi mdi-chevron-${
                                  expandedProjects[pIndex] ? "up" : "down"
                                } font-size-18`}
                              ></i>
                            </td>
                          </tr>

                          {expandedProjects[pIndex] &&
                            warehouseData[project.id].length > 0 && (
                              <>
                                <tr
                                  style={{
                                    backgroundColor: "#A3D1F0",
                                    fontWeight: "900",
                                    position: "sticky",
                                    top: "0px",
                                  }}
                                >
                                  <th style={{ whiteSpace: "nowrap" }}></th>
                                  <th style={{ whiteSpace: "nowrap" }}>
                                    {" "}
                                    Warehouse Name{" "}
                                  </th>
                                  <th style={{ whiteSpace: "nowrap" }}>
                                    {" "}
                                    Warehouse Type{" "}
                                  </th>
                                  <th style={{ whiteSpace: "nowrap" }}>
                                    {" "}
                                    Stock{" "}
                                    {typeCostQTY == "cost" ? "Cost" : "Qty"}
                                  </th>
                                  <th style={{ whiteSpace: "nowrap" }}>
                                    {" "}
                                    Provision{" "}
                                    {typeCostQTY == "cost" ? "Cost" : "Qty"}
                                  </th>
                                  <th style={{ whiteSpace: "nowrap" }}>
                                    {" "}
                                    Shortage{" "}
                                    {typeCostQTY == "cost" ? "Cost" : "Qty"}
                                  </th>
                                  <th style={{ whiteSpace: "nowrap" }}>
                                    {" "}
                                    MRB {typeCostQTY == "cost" ? "Cost" : "Qty"}
                                  </th>
                                  <th style={{ whiteSpace: "nowrap" }}>
                                    {" "}
                                    Scrap{" "}
                                    {typeCostQTY == "cost" ? "Cost" : "Qty"}
                                  </th>
                                  <th style={{ whiteSpace: "nowrap" }}></th>
                                </tr>
                                {warehouseData[project.id]?.map(
                                  (warehouse, wIndex) => (
                                    <React.Fragment key={warehouse.id}>
                                      <tr
                                        // style={{
                                        //   backgroundColor: "#FAD4C9",
                                        // }}
                                        onClick={() =>
                                          toggleWarehouse(
                                            pIndex,
                                            wIndex,
                                            project,
                                            warehouse
                                          )
                                        }
                                        title="Check category wise stock"
                                      >
                                        <td></td>

                                        <td>{warehouse.warehouse_name}</td>
                                        <td>
                                          {warehouse.type === 1
                                            ? "Bermad"
                                            : "Contractor"}
                                        </td>
                                        <td>
                                          {typeCostQTY == "cost"
                                            ? formatNumber(
                                                warehouse.stock_qty_cost
                                              )
                                            : formatNumber(
                                                warehouse.stock_qty || "0"
                                              )}
                                        </td>
                                        <td>
                                          {typeCostQTY == "cost"
                                            ? formatNumber(
                                                warehouse.provision_qty_cost
                                              )
                                            : formatNumber(
                                                warehouse.provision_qty || "0"
                                              )}
                                        </td>
                                        <td>
                                          {typeCostQTY == "cost"
                                            ? formatNumber(
                                                warehouse.shortage_qty_cost
                                              )
                                            : formatNumber(
                                                warehouse.shortage_qty || "0"
                                              )}
                                        </td>
                                        <td>
                                          {typeCostQTY == "cost"
                                            ? formatNumber(
                                                warehouse.mrb_qty_cost
                                              )
                                            : formatNumber(
                                                warehouse.mrb_qty || "0"
                                              )}
                                        </td>
                                        <td>
                                          {typeCostQTY == "cost"
                                            ? formatNumber(
                                                warehouse.scrab_qty_cost
                                              )
                                            : formatNumber(
                                                warehouse.scrab_qty || "0"
                                              )}
                                        </td>
                                        <td style={{ color: "black" }}>
                                          <i
                                            className={`mdi mdi-chevron-${
                                              expandedWarehouses[
                                                `${pIndex}-${wIndex}`
                                              ]
                                                ? "up"
                                                : "down"
                                            } font-size-18`}
                                          ></i>
                                        </td>
                                      </tr>

                                      {expandedWarehouses[
                                        `${pIndex}-${wIndex}`
                                      ] &&
                                        categoryData[
                                          `${project.id}-${warehouse.id}`
                                        ].length > 0 && (
                                          <>
                                            <tr
                                              style={{
                                                backgroundColor: "#C4E1F9",
                                                fontWeight: "900",
                                                position: "sticky",
                                                top: "0px",
                                                // zIndex: ,
                                              }}
                                            >
                                              {" "}
                                              <th
                                                colSpan="2"
                                                style={{
                                                  whiteSpace: "nowrap",
                                                }}
                                              ></th>{" "}
                                              <th
                                                style={{ whiteSpace: "nowrap" }}
                                              >
                                                {" "}
                                                Category Name{" "}
                                              </th>{" "}
                                              <th
                                                style={{ whiteSpace: "nowrap" }}
                                              >
                                                {" "}
                                                Stock{" "}
                                                {typeCostQTY == "cost"
                                                  ? "Cost"
                                                  : "Qty"}{" "}
                                              </th>{" "}
                                              <th
                                                style={{ whiteSpace: "nowrap" }}
                                              >
                                                {" "}
                                                Provision{" "}
                                                {typeCostQTY == "cost"
                                                  ? "Cost"
                                                  : "Qty"}{" "}
                                              </th>{" "}
                                              <th
                                                style={{ whiteSpace: "nowrap" }}
                                              >
                                                {" "}
                                                Shortage{" "}
                                                {typeCostQTY == "cost"
                                                  ? "Cost"
                                                  : "Qty"}{" "}
                                              </th>{" "}
                                              <th
                                                style={{ whiteSpace: "nowrap" }}
                                              >
                                                {" "}
                                                MRB{" "}
                                                {typeCostQTY == "cost"
                                                  ? "Cost"
                                                  : "Qty"}{" "}
                                              </th>{" "}
                                              <th
                                                style={{ whiteSpace: "nowrap" }}
                                              >
                                                {" "}
                                                Scrap{" "}
                                                {typeCostQTY == "cost"
                                                  ? "Cost"
                                                  : "Qty"}{" "}
                                              </th>{" "}
                                              <th
                                                style={{ whiteSpace: "nowrap" }}
                                              ></th>
                                            </tr>
                                            {categoryData[
                                              `${project.id}-${warehouse.id}`
                                            ]?.map((category, cIndex) => (
                                              <React.Fragment key={category.id}>
                                                <tr
                                                  onClick={() =>
                                                    toggleCategory(
                                                      pIndex,
                                                      wIndex,
                                                      cIndex,
                                                      project,
                                                      warehouse,
                                                      category
                                                    )
                                                  }
                                                  // style={{
                                                  //   backgroundColor: "#F6BFA8",
                                                  // }}
                                                  className=""
                                                >
                                                  <td colSpan="2"></td>

                                                  <td>
                                                    {category.category_name ||
                                                      "0"}
                                                  </td>
                                                  <td>
                                                    {typeCostQTY == "cost"
                                                      ? formatNumber(
                                                          category.stock_qty_cost
                                                        )
                                                      : formatNumber(
                                                          category.stock_qty ||
                                                            "0"
                                                        )}
                                                  </td>
                                                  <td>
                                                    {typeCostQTY == "cost"
                                                      ? formatNumber(
                                                          category.provision_qty_cost
                                                        )
                                                      : formatNumber(
                                                          category.provision_qty ||
                                                            "0"
                                                        )}
                                                  </td>
                                                  <td>
                                                    {typeCostQTY == "cost"
                                                      ? formatNumber(
                                                          category.shortage_qty_cost
                                                        )
                                                      : formatNumber(
                                                          category.shortage_qty ||
                                                            "0"
                                                        )}
                                                  </td>
                                                  <td>
                                                    {typeCostQTY == "cost"
                                                      ? formatNumber(
                                                          category.mrb_qty_cost
                                                        )
                                                      : formatNumber(
                                                          category.mrb_qty ||
                                                            "0"
                                                        )}
                                                  </td>
                                                  <td>
                                                    {typeCostQTY == "cost"
                                                      ? formatNumber(
                                                          category.scrab_qty_cost
                                                        )
                                                      : formatNumber(
                                                          category.scrab_qty ||
                                                            "0"
                                                        )}
                                                  </td>
                                                  <td
                                                    style={{
                                                      color: "black",
                                                    }}
                                                  >
                                                    <i
                                                      className={`mdi mdi-chevron-${
                                                        expandedCategories[
                                                          `${pIndex}-${wIndex}-${cIndex}`
                                                        ]
                                                          ? "up"
                                                          : "down"
                                                      } font-size-18`}
                                                    ></i>
                                                  </td>
                                                </tr>
                                               
                                                {expandedCategories[
                                                  `${pIndex}-${wIndex}-${cIndex}`
                                                ] &&
                                                  itemsData[
                                                    `${project.id}-${warehouse.id}-${category.id}`
                                                  ].length > 0 && (
                                                    <>
                                                      <tr
                                                        style={{
                                                          backgroundColor:
                                                            "#E5F1FC",
                                                          fontWeight: "900",
                                                          position: "sticky",
                                                          top: "0px",
                                                        }}
                                                      >
                                                        {" "}
                                                        <th
                                                          style={{
                                                            whiteSpace:
                                                              "nowrap",
                                                          }}
                                                        >
                                                          {" "}
                                                          Sr No{" "}
                                                        </th>{" "}
                                                        <th
                                                          style={{
                                                            whiteSpace:
                                                              "nowrap",
                                                          }}
                                                        >
                                                          {" "}
                                                          Item Code{" "}
                                                        </th>{" "}
                                                        <th
                                                          style={{
                                                            whiteSpace:
                                                              "nowrap",
                                                          }}
                                                        >
                                                          {" "}
                                                          Item Description{" "}
                                                        </th>
                                                        <th
                                                          style={{
                                                            whiteSpace:
                                                              "nowrap",
                                                          }}
                                                        >
                                                          {" "}
                                                          Stock{" "}
                                                          {typeCostQTY == "cost"
                                                            ? "Cost"
                                                            : "Qty"}{" "}
                                                        </th>{" "}
                                                        <th
                                                          style={{
                                                            whiteSpace:
                                                              "nowrap",
                                                          }}
                                                        >
                                                          {" "}
                                                          Provision{" "}
                                                          {typeCostQTY == "cost"
                                                            ? "Cost"
                                                            : "Qty"}{" "}
                                                        </th>{" "}
                                                        <th
                                                          style={{
                                                            whiteSpace:
                                                              "nowrap",
                                                          }}
                                                        >
                                                          {" "}
                                                          Shortage{" "}
                                                          {typeCostQTY == "cost"
                                                            ? "Cost"
                                                            : "Qty"}{" "}
                                                        </th>{" "}
                                                        <th
                                                          style={{
                                                            whiteSpace:
                                                              "nowrap",
                                                          }}
                                                        >
                                                          {" "}
                                                          MRB{" "}
                                                          {typeCostQTY == "cost"
                                                            ? "Cost"
                                                            : "Qty"}{" "}
                                                        </th>{" "}
                                                        <th
                                                          style={{
                                                            whiteSpace:
                                                              "nowrap",
                                                          }}
                                                        >
                                                          {" "}
                                                          Scrap{" "}
                                                          {typeCostQTY == "cost"
                                                            ? "Cost"
                                                            : "Qty"}{" "}
                                                        </th>{" "}
                                                        <th
                                                          style={{
                                                            whiteSpace:
                                                              "nowrap",
                                                          }}
                                                        ></th>
                                                      </tr>

                                                      {itemsData[
                                                        `${project.id}-${warehouse.id}-${category.id}`
                                                      ].map((item, iIndex) => (
                                                        <React.Fragment
                                                          key={iIndex}
                                                        >
                                                          <tr
                                                            onClick={() =>
                                                              toggleBuyItem(
                                                                pIndex,
                                                                wIndex,
                                                                cIndex,
                                                                iIndex,
                                                                project,
                                                                warehouse,
                                                                category,
                                                                item
                                                              )
                                                            }
                                                          >
                                                            <td>
                                                              {iIndex + 1}
                                                            </td>
                                                            <td>
                                                              {item.item_code}
                                                            </td>
                                                            <td>
                                                              <div
                                                                style={{
                                                                  display:
                                                                    "-webkit-box",
                                                                  WebkitBoxOrient:
                                                                    "vertical",
                                                                  WebkitLineClamp: 2,
                                                                  overflow:
                                                                    "hidden",
                                                                  textOverflow:
                                                                    "ellipsis",
                                                                  whiteSpace:
                                                                    "normal",
                                                                }}
                                                                title={
                                                                  item.description ||
                                                                  "N/A"
                                                                }
                                                              >
                                                                {item.description ||
                                                                  "N/A"}
                                                              </div>
                                                            </td>
                                                            <td>
                                                              {item.type == 1
                                                                ? "-"
                                                                : typeCostQTY ==
                                                                  "cost"
                                                                ? formatNumber(
                                                                    item.stock_qty_cost
                                                                  )
                                                                : formatNumber(
                                                                    item.stock_qty ||
                                                                      "0"
                                                                  )}
                                                            </td>
                                                            <td>
                                                              {item.type == 1
                                                                ? "-"
                                                                : typeCostQTY ==
                                                                  "cost"
                                                                ? formatNumber(
                                                                    item.provision_qty_cost
                                                                  )
                                                                : formatNumber(
                                                                    item.provision_qty ||
                                                                      "0"
                                                                  )}
                                                            </td>
                                                            <td>
                                                              {item.type == 1
                                                                ? "-"
                                                                : typeCostQTY ==
                                                                  "cost"
                                                                ? formatNumber(
                                                                    item.shortage_qty_cost
                                                                  )
                                                                : formatNumber(
                                                                    item.shortage_qty ||
                                                                      "0"
                                                                  )}
                                                            </td>
                                                            <td>
                                                              {item.type == 1
                                                                ? "-"
                                                                : typeCostQTY ==
                                                                  "cost"
                                                                ? formatNumber(
                                                                    item.mrb_qty_cost
                                                                  )
                                                                : formatNumber(
                                                                    item.mrb_qty ||
                                                                      "0"
                                                                  )}
                                                            </td>
                                                            <td>
                                                              {item.type == 1
                                                                ? "-"
                                                                : typeCostQTY ==
                                                                  "cost"
                                                                ? formatNumber(
                                                                    item.scrab_qty_cost
                                                                  )
                                                                : formatNumber(
                                                                    item.scrab_qty ||
                                                                      "0"
                                                                  )}
                                                            </td>
                                                            <td
                                                              style={{
                                                                color: "black",
                                                              }}
                                                            >
                                                              {item.type ==
                                                                1 && (
                                                                <i
                                                                  className={`mdi mdi-chevron-${
                                                                    expandedItems[
                                                                      `${pIndex}-${wIndex}-${cIndex}-${iIndex}`
                                                                    ]
                                                                      ? "up"
                                                                      : "down"
                                                                  } font-size-18`}
                                                                ></i>
                                                              )}
                                                            </td>
                                                          </tr>

                                                          {expandedItems[
                                                            `${pIndex}-${wIndex}-${cIndex}-${iIndex}`
                                                          ] &&
                                                            item.type == 1 &&
                                                            subItemsData[
                                                              `${project.id}-${warehouse.id}-${category.id}-${item.id}`
                                                            ]?.map(
                                                              (
                                                                buyItem,
                                                                index
                                                              ) => (
                                                                <tr key={index}>
                                                                  <td
                                                                    style={{
                                                                      paddingLeft:
                                                                        "30px",
                                                                    }}
                                                                  >{`${
                                                                    iIndex + 1
                                                                  }.${
                                                                    index + 1
                                                                  }`}</td>
                                                                  <td>
                                                                    {
                                                                      buyItem.item_code
                                                                    }
                                                                  </td>
                                                                  <td>
                                                                    <div
                                                                      style={{
                                                                        display:
                                                                          "-webkit-box",
                                                                        WebkitBoxOrient:
                                                                          "vertical",
                                                                        WebkitLineClamp: 2,
                                                                        overflow:
                                                                          "hidden",
                                                                        textOverflow:
                                                                          "ellipsis",
                                                                        whiteSpace:
                                                                          "normal",
                                                                      }}
                                                                      title={
                                                                        buyItem.description ||
                                                                        "N/A"
                                                                      }
                                                                    >
                                                                      {buyItem.description ||
                                                                        "N/A"}
                                                                    </div>
                                                                  </td>
                                                                  <td>
                                                                    {typeCostQTY ==
                                                                    "cost"
                                                                      ? formatNumber(
                                                                          project.stock_qty_cost
                                                                        )
                                                                      : formatNumber(
                                                                          project.stock_qty ||
                                                                            "0"
                                                                        )}
                                                                  </td>
                                                                  <td>
                                                                    {typeCostQTY ==
                                                                    "cost"
                                                                      ? formatNumber(
                                                                          project.provision_qty_cost
                                                                        )
                                                                      : formatNumber(
                                                                          project.provision_qty ||
                                                                            "0"
                                                                        )}
                                                                  </td>
                                                                  <td>
                                                                    {typeCostQTY ==
                                                                    "cost"
                                                                      ? formatNumber(
                                                                          project.shortage_qty_cost
                                                                        )
                                                                      : formatNumber(
                                                                          project.shortage_qty ||
                                                                            "0"
                                                                        )}
                                                                  </td>
                                                                  <td>
                                                                    {typeCostQTY ==
                                                                    "cost"
                                                                      ? formatNumber(
                                                                          project.mrb_qty_cost
                                                                        )
                                                                      : formatNumber(
                                                                          project.mrb_qty ||
                                                                            "0"
                                                                        )}
                                                                  </td>
                                                                  <td>
                                                                    {typeCostQTY ==
                                                                    "cost"
                                                                      ? formatNumber(
                                                                          project.scrab_qty_cost
                                                                        )
                                                                      : formatNumber(
                                                                          project.scrab_qty ||
                                                                            "0"
                                                                        )}
                                                                  </td>

                                                                  <td></td>
                                                                </tr>
                                                              )
                                                            )}
                                                        </React.Fragment>
                                                      ))}
                                                    </>
                                                  )}
                                              </React.Fragment>
                                            ))}
                                          </>
                                        )}
                                    </React.Fragment>
                                  )
                                )}
                                {pIndex !== currentRecords.length - 1 && (
                                  <tr
                                    style={{
                                      backgroundColor: "#6FAFDB",
                                      fontWeight: "900",
                                      position: "sticky",
                                      top: "0px",
                                    }}
                                  >
                                    <th style={{ whiteSpace: "nowrap" }}>
                                      {" "}
                                      Sr No{" "}
                                    </th>
                                    <th style={{ whiteSpace: "nowrap" }}>
                                      {" "}
                                      Project Name{" "}
                                    </th>
                                    <th style={{ whiteSpace: "nowrap" }}>
                                      Project Code
                                    </th>
                                    <th style={{ whiteSpace: "nowrap" }}>
                                      Stock{" "}
                                      {typeCostQTY == "cost" ? "Cost" : "Qty"}
                                    </th>
                                    <th style={{ whiteSpace: "nowrap" }}>
                                      Provision{" "}
                                      {typeCostQTY == "cost" ? "Cost" : "Qty"}
                                    </th>
                                    <th style={{ whiteSpace: "nowrap" }}>
                                      Shortage{" "}
                                      {typeCostQTY == "cost" ? "Cost" : "Qty"}
                                    </th>
                                    <th style={{ whiteSpace: "nowrap" }}>
                                      MRB{" "}
                                      {typeCostQTY == "cost" ? "Cost" : "Qty"}
                                    </th>
                                    <th style={{ whiteSpace: "nowrap" }}>
                                      Scrap{" "}
                                      {typeCostQTY == "cost" ? "Cost" : "Qty"}
                                    </th>
                                    <th style={{ whiteSpace: "nowrap" }}></th>
                                  </tr>
                                )}
                              </>
                            )}
                        </React.Fragment>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="10" className="text-center">
                          No data available.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              <div className="d-flex justify-content-between align-items-center mt-3">
                <button
                  className="btn btn-primary"
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage(currentPage - 1)}
                >
                  Previous
                </button>
                <span>
                  Page {currentPage} of {totalPages}
                </span>
                <button
                  className="btn btn-primary"
                  disabled={currentPage === totalPages || totalPages === 0}
                  onClick={() => setCurrentPage(currentPage + 1)}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </CustomForm>
  );
};

export default AvailableStocks;
